import React from 'react'
import { Badge } from 'antd'
import PropTypes from 'prop-types'
import { THEME } from '../../../../core/constants'
import {
  MENU_VALIDATION_STATUSES,
  MENU_VALIDATION_SUCCESS,
  MENU_VALIDATION_PARTIAL_SUCCESS,
  MENU_VALIDATION_ERROR,
  MENU_VALIDATION_NOT_VALIDATED,
} from '../../../constants'

const backgroundColorByStatus = {
  [MENU_VALIDATION_SUCCESS]: THEME.colors.green,
  [MENU_VALIDATION_PARTIAL_SUCCESS]: THEME.colors.orange,
  [MENU_VALIDATION_ERROR]: THEME.colors.red,
  [MENU_VALIDATION_NOT_VALIDATED]: THEME.colors.greyBlue,
}

const ScrapingMenuValidationStatus = ({ status }) => {
  const validationStatus = MENU_VALIDATION_STATUSES[status]
    ? status
    : MENU_VALIDATION_NOT_VALIDATED

  return (
    <Badge
      count={MENU_VALIDATION_STATUSES[validationStatus].name}
      style={{ backgroundColor: backgroundColorByStatus[validationStatus] }}
    />
  )
}

ScrapingMenuValidationStatus.propTypes = {
  status: PropTypes.string,
}

ScrapingMenuValidationStatus.defaultProps = {
  status: MENU_VALIDATION_NOT_VALIDATED,
}

export default ScrapingMenuValidationStatus
